import axios from '@/axios.js'

const state = () => ({
    shifts: [],
    shiftjadwals: [],
})

const mutations = {
  SET_SHIFT (state, payload) {
    state.shifts = payload
  },
  SET_SHIFTJADWAL (state, payload) {
    state.shiftjadwals = payload
  },
  UPDATE_SHIFT (state, shift) {
    const shiftIndex = state.shifts.findIndex((p) => p.id === shift.id)
    Object.assign(state.shifts[shiftIndex], shift)
  },
  UPDATE_SHIFTJADWAL (state, schedule) {
    const scheduleIndex = state.shiftjadwals.findIndex((p) => p.idregu === schedule.idregu)
    Object.assign(state.shiftjadwals[scheduleIndex], schedule)
  },
}

const actions = {
  fetchShift ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/shift-list')
        .then((response) => {
          commit('SET_SHIFT', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchShiftJadwal ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/shift-schedule')
        .then((response) => {
          commit('SET_SHIFTJADWAL', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateShift ({ commit }, shift) {
    return new Promise((resolve, reject) => {
      axios.post(`/shift-update/`, shift)
        .then((response) => {
          commit('UPDATE_SHIFT', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateSchedule ({ commit }, schedule) {
    return new Promise((resolve, reject) => {
      axios.post(`/schedule-update/`, schedule)
        .then((response) => {
          commit('UPDATE_SHIFTJADWAL', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}